import { OptionDto, RowRouteGroupDto } from "@/dtos";
import { RouteGroup } from "@/entities";

export const formatRowRouteGroup = async (routeGroups: RouteGroup[]): Promise<RowRouteGroupDto[]> => {
    return routeGroups.map((x) => {
        const row: RowRouteGroupDto = {
            ...x,
            id: x.id,
            name: x.name,
            order: x.order,
            is_active: x.is_active,
        }
        return row;
    });
}

export const formatOptionsRouteGroup = (routeGroups: RouteGroup[]): OptionDto[] => {
    return routeGroups.map((x) => {
        const opt: OptionDto = {
            label: x.name,
            value: x.id
        }
        return opt;
    });
}

export const getRouteByName = (routeGroups: RouteGroup[], name: string) => {
    for (const routeGroup of routeGroups) {
        const route = routeGroup.routes.find(x => x.long_name == name);
        if (route) {
            return route;
        }
    }
}

export const getTripPatternByName = (routeGroups: RouteGroup[], name: string) => {
    for (const routeGroup of routeGroups) {
        for (const route of routeGroup.routes) {
            const tripPattern = route.tripPattern.find(x => x.name == name);
            if (tripPattern) {
                return tripPattern;
            }
        }
    }
}

export const getCheckpointByName = (routeGroups: RouteGroup[], name: string) => {
    for (const routeGroup of routeGroups) {
        for (const route of routeGroup.routes) {
            for (const tripPattern of route.tripPattern) {
                const checkpoint = tripPattern.trip_pattern_checkpoints.find(x => x.checkpoint.name == name);
                if (checkpoint) {
                    return checkpoint;
                }
            }
        }
    }
}